import React, { Component } from "react";
import ReactQuill, { Quill } from "react-quill";
import quillEmoji from "quill-emoji";
import { gql } from "@apollo/client";
import { apolloClient } from "../../../index";
import "../DocumentComments/DocumentComments.scss";
import sendIcon from "../../../assets/icons/send.svg";
import paperClip from "../../../assets/icons/paperclip-solid.svg";
import closeIcon from "../../../assets/icons/close.svg";
import fileIcon from "../../../assets/icons/file_pdf.svg";
import notFoundIcon from "../../../assets/icons/not_found.svg";
import noCommentIcon from "../../../assets/icons/no_comment.png";
import ProfileWithName from "../../ListView/ListViewRows/ProfileWithName/ProfileWIthName";
import { getIntials, getName, getParsedDate } from "../../../helper";
import { notify } from "../../Notify/Notify";
import { connect } from "react-redux";
import { mapStateToProps } from "../../../common/UserDataReducer";
import ShareWithDetails from "../../SharedWith/SharedWithDetails/SharedWithDetails";
import { uploadClient } from "../../../index";
import SortByDropDown from "../../UI/SortByDropDown/SortByDropDown";
// Animation import
import UseAnimations from "react-useanimations";
import download from "react-useanimations/lib/download";
import arrowUpCircle from "react-useanimations/lib/arrowUpCircle";
import trash from "react-useanimations/lib/trash2";
import edit from "react-useanimations/lib/edit";
import loading from "react-useanimations/lib/infinity";

// Register quill-emoji
const { EmojiBlot, ShortNameEmoji, ToolbarEmoji } = quillEmoji;
Quill.register(
  {
    "formats/emoji": EmojiBlot,
    "modules/emoji-shortname": ShortNameEmoji,
    "modules/emoji-toolbar": ToolbarEmoji,
  },
  true
);

let Block = Quill.import("blots/block");

Block.tagName = "DIV";
Quill.register(Block, true);

// configure react-quill
const toolbarOptions = {
  toolbar: "#toolbar",
  "emoji-toolbar": true,
  "emoji-shortname": true,
};

class PersonalNotes extends Component {
  state = {
    commentInputValue: "",
    comments: [],
    editMode: false,
    showMentionPopover: false,
    matchedUsersList: [],
    currentCommentObj: undefined,
    sharedWithUsersList: [],
    filesToUpload: [],
    fileUploading: [],
    editFileUploading: false,
    searchCommentValue: "",
    showSearchComment: false,
    selectedColumn: "All",
  };

  commentInputRef = React.createRef();
  messagesEndRef = React.createRef();
  hiddenFileInput = React.createRef();
  commentSearchDropdownRef = React.createRef();

  componentDidMount() {
    this.updateComment();
    this.getSharedUsers();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.comments !== this.props.comments) {
      this.updateComment();
    }
  }
  componentWillUnmount() {
    this.props.loadNotes();
  }

  getSharedUsers = () => {
    const GET_SHARED_USERS = `query DocumentSharedWith($documentId: UUID!) {
      documentSharedWith(documentId: $documentId){
        document{
          title
        }
        user{
          id
          email
          username
          firstName
          lastName
          username
          profile{
            image
            role{
              name
            }
          }
        }
        userRole{
          id
          name
        }
        expiredTs
      }
    }`;
    const variables = {
      documentId: this.props.documentObj.id,
    };

    apolloClient
      .query({
        query: gql`
          ${GET_SHARED_USERS}
        `,
        variables: variables,
      })
      .then((result) => {
        let sharedWithUsersList = [];
        const res = result.data.documentSharedWith;
        res.map((folderShare) => {
          return sharedWithUsersList.push({
            id: folderShare.user.id,
            email: folderShare.user.email,
            username: folderShare.user.username,
            firstName: folderShare.user.firstName,
            lastName: folderShare.user.lastName,
            user: folderShare.user,
            profile: folderShare.user.profile.image,
            role: folderShare.user.profile.role.name,
          });
        });
        this.setState({ sharedWithUsersList });
      })
      .catch((e) => {
        const detail = "Error";
        const title = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(detail, title, type);
      });
  };

  updateComment = () => {
    this.setState(
      {
        comments: this.props.comments.map((commentObj) => {
          const obj = this.getParsedComment(commentObj.note);
          return {
            comment: obj.comment,
            originalComment: commentObj.note,
            emailList: obj.emailList,
            ...commentObj,
          };
        }),
      },
      () => this.scrollToBottom()
    );
  };

  extractHtmlComments = (comment) => {
    return comment.replace(/(<\/?)[A-Za-z]+>/g, "");
  };

  hasValidValues = () => {
    const commentInputValue = this.extractHtmlComments(
      this.state.commentInputValue
    );
    return (
      commentInputValue.trim().length > 0 || this.state.filesToUpload.length > 0
    );
  };

  getParsedComment = (commentText, shouldExtractUserIdAsEmail = false) => {
    const extractEmails = (text) => {
      return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
    };

    let emailList = extractEmails(commentText) || [];
    let usersList = this.state.sharedWithUsersList || [];
    var myRegExp;
    for (let index = 0; index < emailList.length; index++) {
      const email = emailList[index];
      myRegExp = new RegExp(email, "i");
      commentText = commentText.replace(myRegExp, "");
    }

    for (let index = 0; index < usersList.length; index++) {
      const userName =
        usersList[index].firstName + " " + usersList[index].lastName;
      myRegExp = new RegExp("@" + userName, "i");
      let olderText = commentText;
      commentText = commentText.replace(
        myRegExp,
        `<span class='user-name'>@${userName}</span>`
      );

      if (shouldExtractUserIdAsEmail && commentText !== olderText) {
        emailList.push(usersList[index].email);
      }
    }

    return {
      comment: commentText.trim(),
      emailList,
    };
  };

  addCommentHandler = () => {
    this.scrollToBottom();
    let originalComment = this.state.commentInputValue;
    let commentText = this.state.commentInputValue;
    const obj = this.getParsedComment(commentText, true);
    commentText = obj.comment;
    let emailList = obj.emailList;
    let commentObj = {
      comment: commentText,
      originalComment: originalComment,
      emailList: emailList,
    };

    if (this.state.editMode) {
      this.editCommentAPI(commentObj);
    } else {
      this.addNewCommentAPI(commentObj);
    }
  };

  addAttachmentAPI = async (noteId, comments) => {
    const fileUploading = [...this.state.fileUploading];
    let filesUploaded = [];
    for (let index = 0; index < fileUploading.length; index++) {
      // Request argument
      let variables = {
        noteId: noteId,
        name: fileUploading[index].name,
        size: fileUploading[index].size,
        attachment: fileUploading[index],
      };

      // Request query
      const UPLOAD_ATTACHMENT = gql`
        mutation addNoteAttachment(
          $noteId: UUID!
          $name: String!
          $size: Int!
          $attachment: Upload!
        ) {
          addNoteAttachment(
            noteId: $noteId
            name: $name
            size: $size
            attachment: $attachment
          ) {
            success
            noteAttachment {
              id
              name
              size
              attachmentFileUrl
            }
          }
        }
      `;

      // Backend request
      await uploadClient
        .mutate({
          mutation: UPLOAD_ATTACHMENT,
          variables: variables,
        })
        .then((result) => {
          if (result.data.addNoteAttachment.success) {
            let attachmentUploaded =
              result.data.addNoteAttachment.noteAttachment;
            filesUploaded.push(attachmentUploaded);
          }
        });
    }
    let updatedComments = [...comments].map((comment) => {
      const updatedComment = comment;
      if (updatedComment.id === noteId) {
        if (this.state.editFileUploading) {
          const updatedCommentAttachment = [
            ...filesUploaded,
            ...updatedComment.noteAttachment,
          ];
          const updatedAttachment = updatedCommentAttachment
            .filter((attachment) => attachment.id !== null)
            .reverse();

          updatedComment.noteAttachment = updatedAttachment;
        } else {
          updatedComment.noteAttachment = filesUploaded;
        }
      }
      return updatedComment;
    });

    this.setState({
      comments: updatedComments,
      fileUploading: [],
      editFileUploading: false,
    });
  };

  addNewCommentAPI = (commentObj) => {
    const variables = {
      documentId: this.props.documentObj.id,
      note: commentObj.originalComment,
      userList: commentObj.emailList,
      personalNote: true,
      usersEmail : [],
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation createDocumentNote(
            $documentId: UUID!
            $note: String
            $userList: [String]
            $usersEmail : [String]
            $personalNote: Boolean!
          ) {
            createDocumentNote(
              documentId: $documentId
              note: $note
              userList: $userList
              usersEmail : $usersEmail
              personalNote: $personalNote
            ) {
              success
              documentNote {
                id
                noteAttachment {
                  id
                  name
                  size
                  attachmentFileUrl
                }
                createdTs
                createdBy {
                  id
                  firstName
                  lastName
                  email
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then(async (result) => {
        let comments = [...this.state.comments];
        // let filesUploaded = [];
        const noteId = result.data.createDocumentNote.documentNote.id;

        let updatedComment = { ...result.data.createDocumentNote.documentNote };

        updatedComment.noteAttachment = [...this.state.filesToUpload].map(
          (file) => {
            return {
              id: null,
              name: file.name,
              size: file.size,
              attachmentFileUrl: null,
              uploading: true,
            };
          }
        );

        comments = [
          { ...updatedComment, ...commentObj },
          ...this.state.comments,
        ];

        await this.setState({ fileUploading: [...this.state.filesToUpload] });

        await this.setState(
          {
            comments,
            commentInputValue: "",
            editMode: false,
            filesToUpload: [],
          },
          () => {
            if (this.state.fileUploading.length > 0) {
              this.addAttachmentAPI(noteId, comments);
            }
          }
        );
        this.scrollToBottom();
      })
      .catch((e) => {
        const title = "Error";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
  };

  editCommentAPI = (commentObj) => {
    const variables = {
      documentId: this.props.documentObj.id,
      noteId: this.state.currentCommentObj.id,
      note: commentObj.originalComment,
      userList: commentObj.emailList,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation editDocumentNote(
            $documentId: UUID!
            $noteId: UUID!
            $note: String!
            $userList: [String]
          ) {
            editDocumentNote(
              documentId: $documentId
              noteId: $noteId
              note: $note
              userList: $userList
            ) {
              success
              documentNote {
                id
                noteAttachment {
                  id
                  name
                  size
                  attachmentFileUrl
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then(async (result) => {
        let UpdatedCommentAttachment = {
          ...result.data.editDocumentNote.documentNote.noteAttachment,
        };

        UpdatedCommentAttachment = [...this.state.filesToUpload].map((file) => {
          return {
            id: file.id ? file.id : null,
            name: file.name,
            size: file.size,
            attachmentFileUrl: file.attachmentFileUrl
              ? file.attachmentFileUrl
              : null,
            uploading: file.id ? false : true,
          };
        });

        let comments = this.state.comments.map((comment) => {
          let updatedComment = comment;
          if (
            updatedComment.id === result.data.editDocumentNote.documentNote.id
          ) {
            updatedComment.comment = commentObj.comment;
            updatedComment.originalComment = commentObj.originalComment;
            updatedComment.emailList = commentObj.emailList;
            updatedComment.noteAttachment = UpdatedCommentAttachment;
          }
          return updatedComment;
        });

        this.setState({ comments });

        await this.setState(
          {
            commentInputValue: "",
            editMode: false,
            filesToUpload: [],
            editFileUploading: true,
          },
          () => {
            if (this.state.fileUploading.length > 0) {
              this.addAttachmentAPI(this.state.currentCommentObj.id, comments);
            }
          }
        );
      })
      .catch((e) => {
        const title = "Error";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
  };

  onDeleteCommentHandler = (commentObj) => {
    const variables = {
      documentId: this.props.documentObj.id,
      noteId: commentObj.id,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation deleteDocumentNote($documentId: UUID!, $noteId: UUID!) {
            deleteDocumentNote(documentId: $documentId, noteId: $noteId) {
              success
              documentNote {
                id
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        this.removeAttachment(null, commentObj.id);
        this.setState({
          comments: this.state.comments.filter(
            (cObj) => cObj.id !== commentObj.id
          ),
        });
        this.props.loadNotes();
        notify("Success", "Comment deleted successfully", "success");
      })
      .catch((e) => {
        const title = "Error";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
  };

  onEditCommentHandler = (commentObj) => {
    this.commentInputRef.current.focus();
    this.setState({
      commentInputValue: commentObj.originalComment,
      currentCommentObj: commentObj,
      editMode: true,
      filesToUpload: commentObj.noteAttachment,
    });
  };

  checkCommentPresent = (commentList, commentId) => {
    const checkAvailable = commentList.filter(
      (filterComment) => filterComment.id === commentId
    );
    return checkAvailable.length !== 0 ? true : false;
  };

  getHighlightedText = (text, highlight) => {
    if (!highlight.trim()) {
      return text;
    }
    const regex = new RegExp(`(${highlight})`, "gi");
    const parts = text.split(regex);
    const updatedParts = parts
      .filter((part) => part)
      .map((part, i) =>
        regex.test(part) ? <mark key={i}>{part}</mark> : part
      );

    let newText = "";
    [...updatedParts].map(
      (parts) =>
        (newText =
          newText +
          (typeof parts === "object"
            ? `<${parts["type"]}>${highlight}</${parts["type"]}>`
            : parts))
    );
    return newText;
  };

  commentSearch = (allComments) => {
    let filteredSearchComment = [];

    const getMainSearchComment = (mainComment) => {
      let commentText = this.extractHtmlComments(mainComment.comment);
      const searchText = this.state.searchCommentValue;
      if (
        commentText.toLowerCase().includes(searchText.toLowerCase()) &&
        !this.checkCommentPresent(filteredSearchComment, mainComment.id)
      ) {
        mainComment.comment = this.getHighlightedText(
          mainComment.comment,
          searchText
        );
        filteredSearchComment.push(mainComment);
      }
    };

    allComments.forEach((commentObj) => {
      let comment = { ...commentObj };
      getMainSearchComment(comment);
    });
    return filteredSearchComment;
  };

  handleSearchCommentInputChange = (event) => {
    const searchCommentValue = event.target.value;
    const showSearchComment =
      searchCommentValue.trim().length > 0 ? true : false;
    return this.setState({ showSearchComment, searchCommentValue });
  };

  getCommentsJSX = (comments) => {
    const getEmailList = (emailList) => {
      return emailList.map((email, index) => (
        <div key={index} className={`email-frame`}>
          <p>{email}</p>
        </div>
      ));
    };

    let allComments = [...comments];
    allComments.reverse();

    // Check comments available
    if (allComments.length === 0)
      return (
        <p className="no-comment">
          <img src={noCommentIcon} alt="" width="30" height="30" />
          <label>The document doesn't have any personal note currently!</label>
        </p>
      );

    // Comment search
    if (this.state.showSearchComment) {
      allComments = this.commentSearch(allComments);
    }

    // Comment sorting on attachment
    if (this.state.selectedColumn === "Attachment") {
      let filteredAttachmentComment = allComments.filter(
        (commentObj) => commentObj.noteAttachment.length > 0
      );
      allComments = filteredAttachmentComment;
    }

    return allComments.length > 0 ? (
      allComments.map((commentObj, index) => {
        return (
          <div className="comment-slide" style={{ boxShadow: "none", paddingBottom: "5px" }} key={index}>
            {/* Comment header */}
            <div className="parent-comment">
              <div className="first-row">
                <div className="d-flex pl-1">
                  {/* Comment user */}
                  <ProfileWithName
                    nameIntial={getIntials(commentObj.createdBy)}
                    personName={getName(commentObj.createdBy)}
                    profile={commentObj.createdBy.profile.image}
                    isPopover={true}
                    role={
                      commentObj.createdBy.profile
                        ? commentObj.createdBy.profile.role.name
                        : ""
                    }
                  />

                  <span className="timestamp">
                    {getParsedDate(commentObj.createdTs)}
                  </span>
                </div>
                {/* Comment action icons */}
                {!this.props.archiveView ? (
                  <div className="comment-action align-items-center ">
                    {/* Comment edit */}
                    <UseAnimations
                      className="comment-edit-icon"
                      animation={edit}
                      strokeColor="#9d9da0"
                      onClick={() => this.onEditCommentHandler(commentObj)}
                    />

                    {/* Comment delete */}
                    <UseAnimations
                      className="comment-delete-icon"
                      animation={trash}
                      strokeColor="#9d9da0"
                      onClick={() => this.onDeleteCommentHandler(commentObj)}
                    />
                  </div>
                ) : null}
              </div>

              {/* Comment content */}
              <div className="content-row mx-8">
                <p
                  className="comment-text"
                  dangerouslySetInnerHTML={{ __html: commentObj.comment }}
                ></p>
              </div>

              {/* Comment attachments */}
              <div className="mx-6">
                {commentObj.noteAttachment.length > 0 && (
                  <div className="attachment-section">
                    {commentObj.noteAttachment.map((file) => (
                      <div className="attachment-item">
                        <div className="attachment-file-icon">
                          <img src={fileIcon} alt="file" />
                        </div>
                        <div className="attachment-description">
                          <label className="attachment-name is-size-body-1 bold">
                            {file.name}
                          </label>
                          <label className="attachment-size .is-size-body-2 bold">
                            {this.formatBytes(file.size)}
                          </label>
                        </div>
                        {!file.uploading ? (
                          <div className="attachment-download-icon ml-auto">
                            <a
                              href={file.attachmentFileUrl}
                              fileName={file.name}
                              download
                            >
                              <UseAnimations animation={download} />
                            </a>
                          </div>
                        ) : (
                          <div className="ml-auto">
                            <UseAnimations
                              animation={arrowUpCircle}
                              autoplay={true}
                              loop={true}
                              strokeColor="Blue"
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Comment mention */}
            <div className="content-row mx-8">
              {commentObj.emailList.length > 0 ? (
                <div className="emails">
                  {getEmailList(commentObj.emailList)}
                </div>
              ) : null}
            </div>
          </div>
        );
      })
    ) : (
      <div className="no-comment">
        <img src={notFoundIcon} width="30" height="30" alt="" />
        <label> No results found!</label>
      </div>
    );
  };

  handleInputChange = (val) => {
    let showMentionPopover = false;
    let matchedUsersList = [];
    let currentUserNameQuery = "";
    // let val1 = val.replaceAll(/(<\/?)[A-Za-z]+>/g, "");
    let val1 = val;
    if (val1.slice(-2).trim() === "@") {
      showMentionPopover = true;
      matchedUsersList = [...this.state.sharedWithUsersList];
    } else {
      let userName = "";

      if (val1.lastIndexOf("@") >= 0) {
        userName = val1.slice(val1.lastIndexOf("@") + 1).toLowerCase();
      }

      if (userName.length > 0) {
        currentUserNameQuery = userName;
        matchedUsersList = this.state.sharedWithUsersList.filter((item) =>
          (item.firstName + " " + item.lastName)
            .toLowerCase()
            .includes(userName)
        );
        showMentionPopover = matchedUsersList.length > 0;
      }
    }

    this.setState({
      commentInputValue: val,
      showMentionPopover,
      matchedUsersList,
      currentUserNameQuery,
    });
  };

  addUserToMentionedList = (userObj, onEnter) => {
    let commentInputValue = this.state.commentInputValue;
    let findLastIndex = commentInputValue
      .toLowerCase()
      .lastIndexOf(this.state.currentUserNameQuery.toLowerCase());
    let pat = new RegExp(this.state.currentUserNameQuery, "i");
    let username =
      (userObj.firstName + " " + userObj.lastName).toLowerCase() + " ";
    commentInputValue =
      commentInputValue.slice(0, findLastIndex) +
      commentInputValue.slice(findLastIndex).replace(pat, username);

    this.setState(
      {
        commentInputValue,
        showMentionPopover: false,
        matchedUsersList: [],
        currentUserNameQuery: "",
      },
      () => {
        if (onEnter) {
          // get the current index value
          const cursorPosition =
            this.commentInputRef.current.editor.getSelection().index;
          // set the cursor to the end of line
          this.commentInputRef.current.editor.setSelection(
            cursorPosition + commentInputValue.length
          );
        }
      }
    );
  };

  getMentionPopoverJSX = () => {
    return this.state.matchedUsersList.length > 0 ? (
      this.state.matchedUsersList.map((userObj) => (
        <div className="mention-slide">
          <span onClick={() => this.addUserToMentionedList(userObj, false)}>
            <div className="d-flex">
              <div>
                <ShareWithDetails
                  key={userObj.user.profile.id}
                  nameIntial={getIntials(userObj.user)}
                  personName={getName(userObj.user)}
                  profile={userObj.profile}
                  isPopover={true}
                  role={userObj.role}
                />
              </div>
              <div className="pl-2">
                <strong>{getName(userObj.user)}</strong>
              </div>
              <div className="pl-1">| {userObj.email}</div>
            </div>
          </span>
        </div>
      ))
    ) : (
      <p>No user found.</p>
    );
  };

  onEnterPressed = (e) => {
    if (e.keyCode === 13) {
      if (
        this.state.showMentionPopover &&
        this.state.matchedUsersList.length > 0
      ) {
        e.preventDefault();
        this.addUserToMentionedList(
          this.state.matchedUsersList[this.state.matchedUsersList.length - 1],
          true
        );
      }
    }
  };

  scrollToBottom = () => {
    this.messagesEndRef.scrollIntoView();
  };

  addAttachment = (event) => {
    const files = event.target.files[0];
    const filesToUpload = [...this.state.filesToUpload];
    const fileUploading = [...this.state.fileUploading];

    filesToUpload.push(files);
    if (this.state.editMode) {
      fileUploading.push(files);
    }
    this.setState({ filesToUpload, fileUploading });
  };

  // Remove attachment from the comment
  removeAttachment = (file, noteId) => {
    if (this.state.editMode && file) {
      // remove attachment while comment edit
      const variables = {
        attachmentId: file.id,
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation removeNoteAttachment($attachmentId: UUID) {
              removeNoteAttachment(attachmentId: $attachmentId) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.removeNoteAttachment.success) {
            this.setState({
              filesToUpload: this.state.filesToUpload.filter(
                (item) => item.id !== file.id
              ),
            });
            this.props.loadNotes();
          }
        })
        .catch((e) => {
          const title = "Error";
          const detail = "Oops!! some error occurred please try again.";
          const type = "error";
          notify(title, detail, type);
        });
    } else {
      // Delete all attachment on the comment delete.
      const variables = {
        noteId: noteId,
      };
      apolloClient.mutate({
        mutation: gql`
          mutation removeNoteAttachment($noteId: UUID) {
            removeNoteAttachment(noteId: $noteId) {
              success
            }
          }
        `,
        variables: variables,
      });
    }
    // Remove the added attachment while adding new comment
    this.setState({
      filesToUpload: this.state.filesToUpload.filter((item) => item !== file),
    });
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  render() {
    return (
      <div className="document-comments-container mx-6">
        {/* comments Header */}
        <div className="comment-header">
          {/* Comments Search */}
          <input
            type="text"
            maxLength="50"
            placeholder="&#xF002; Search"
            className="search-placeholder"
            value={this.state.searchCommentValue}
            onChange={(event) => this.handleSearchCommentInputChange(event)}
          />
          <img
            className="close"
            src={closeIcon}
            alt="close"
            onClick={() =>
              this.setState({
                showSearchComment: false,
                searchCommentValue: "",
              })
            }
          />

          {/* Comments sort */}
          <div className="comment-sort">
            <SortByDropDown
              isComment={true}
              selectedColumn={this.state.selectedColumn}
              sortColumnHandler={(value) => {
                this.setState({ selectedColumn: value });
              }}
            />
          </div>
        </div>

        {/* Mention popover */}
        <div className="mt-16 comments-list">
          {this.props.showLoader ? (
            <div style={{ paddingLeft: "50%" }}>
              <UseAnimations animation={loading} autoplay={true} loop={true} strokeColor="Blue" />
            </div>
          ) : (
            this.getCommentsJSX(this.state.comments)
          )}
          <div
            style={{ float: "left", clear: "both" }}
            ref={(el) => {
              this.messagesEndRef = el;
            }}
          ></div>
        </div>

        {!this.props.archiveView ? (
          <div className="input-section">
            <div className="form-group comment-form-group">
              {this.state.showMentionPopover ? (
                <div className="mention-popover">{this.getMentionPopoverJSX()}</div>
              ) : null}
              {/* React-quill editor */}
              <ReactQuill
                ref={this.commentInputRef}
                theme="snow"
                placeholder="Add a personal note here"
                value={this.state.commentInputValue}
                onChange={this.handleInputChange}
                modules={toolbarOptions}
                onKeyUp={this.onEnterPressed}
              />

              {/* ToolBar */}
              <div id="toolbar">
                {/* Attachment section */}
                {this.state.filesToUpload.length > 0 && (
                  <div
                    className={[
                      "attachment-section",
                      this.state.filesToUpload.length > 0 ? "show-attach-section" : "",
                    ].join(" ")}
                  >
                    {this.state.filesToUpload.length > 0 &&
                      this.state.filesToUpload.map((file) => (
                        <div className="attachment-item">
                          <div className="attachment-file-icon">
                            <img src={fileIcon} alt="file" />
                          </div>
                          <div className="attachment-description">
                            <label className="attachment-name is-size-body-1 bold">{file.name}</label>
                            <label className="attachment-size .is-size-body-2 bold">
                              {this.formatBytes(file.size)}
                            </label>
                          </div>
                          <div
                            className="attachment-close-icon ml-auto"
                            onClick={() => this.removeAttachment(file, null)}
                          >
                            <img src={closeIcon} alt="file" />
                          </div>
                        </div>
                      ))}
                  </div>
                )}
                {/* Tools */}
                <div>
                  <button class="ql-bold"></button>
                  <button class="ql-italic"></button>
                  <button class="ql-underline"></button>
                  <button class="ql-strike"></button>
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                  <button class="ql-link"></button>
                  <button class="ql-emoji"></button>
                  <button className="ql-attachment" onClick={() => this.hiddenFileInput.current.click()}>
                    <img src={paperClip} width="16" height="16" alt="attachment" />
                  </button>
                  <input
                    type="file"
                    ref={this.hiddenFileInput}
                    onChange={this.addAttachment}
                    accept=".pdf, .xls, xlsx, .csv, .doc, .docx, .png, .jpg, .jpeg"
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            </div>
            <button
              className="ic-primary add-comment"
              disabled={!this.hasValidValues()}
              onClick={this.addCommentHandler}
            >
              <img src={sendIcon} alt="Send" />
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connect(mapStateToProps)(PersonalNotes);
